import React from "react";
import FilterValues from "Mapa/types/FilterValues";
import { Autocomplete, TextField } from "@mui/material";

export const FilterCard = ({
  filters,
  handleOnChange,
  values,
}: {
  filters: Object;
  handleOnChange: ({ type, value }: { type: string; value: number }) => void;
  values: FilterValues;
}) => {
  return (
    <div className="absolute bg-[rgba(255,255,255,.6)] top-[165px] left-[15px] max-w-sm rounded-[15px] overflow-hidden shadow-lg py-[10px] px-2 w-64 filter-c-top">
      <p className="font-bold text-[18px] mb-[4px]">Filtrar</p>

      {filters &&
        Object.entries(filters).map(([key, array]: any) => {
          //@ts-ignore
          //const valueInput: any = values[key];
          return (
            <div className="relative w-full" key={key}>
              <Autocomplete
                options={array}
                getOptionLabel={(option: any) => option.name}
                onChange={(event: any, value: any) => {
                  handleOnChange({
                    type: key,
                    value: value,
                  });
                }}
                //@ts-ignore
                value={values[key]}
                fullWidth
                id={`id-${key}`}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={`Filtro por ${key}`}
                    variant="standard"
                    inputProps={{ ...params.inputProps }}
                  />
                )}
              />
              {/* <select
                className="text-sm block appearance-none w-full bg-opacity-50 bg-transparent border-b-2 border-black px-4 py-2 pr-8 leading-tight hover:border-black focus:outline-none focus:shadow-outline"
                onChange={(event) => {
                  if (!event.target.value) return;

                  handleOnChange({
                    type: key,
                    value: parseInt(event.target.value),
                  });
                }}
                //@ts-ignore
                value={values[key] || ""}
              >
                <option key={`option-${key}`}>Filtro por {key}</option>
                {array.map((object: any, index: number) => (
                  <option key={`option-${index}`} value={object.id}>
                    {object.name}
                  </option>
                ))}
              </select> */}
            </div>
          );
        })}
    </div>
  );
};
